import React, { Component } from 'react';
import { database } from '../App';
import moment from 'moment';

import '../Code.css';
import Backspace from '@material-ui/icons/Backspace';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
});

// error message
function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby='client-snackbar'
      message={
        <span id='client-snackbar' className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key='close'
          aria-label='Close'
          color='inherit'
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

class Main extends Component {
  state = {
    offer: {},
    cashiers: [],
    password: '',
    numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    error: false,
    offerTaken: false
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ offerTaken: false });
  };

  componentDidMount() {
    database
      .ref(`/restaurants/0/${this.props.restaurant_name}/offers`)
      .on('value', snapshot => {
        const snap = snapshot.val();
        if (snap) {
          this.setState({
            offer: snap.offers.find(offer => offer.id === this.props.promoCode),
            cashiers: snap.cashiers
          });
        }
      });
  }

  validatePassword = () => {
    const { restaurant_name, messenger_user_id } = this.props;

    const cashier = this.state.cashiers.find(
      cashier => cashier.password === this.state.password
    );

    if (cashier) {
      let redeemedOffers = this.props.redeemedOffers;

      const offer = redeemedOffers.find(offer => {
        return offer.id === this.props.promoCode;
      });

      const sendOffer = {
        ...this.state.offer,
        timestamp: moment().format()
      };

      if (!offer) {
        database
          .ref(`restaurants/0/${restaurant_name}/users/${messenger_user_id}`)
          .update({
            redeemedOffers: redeemedOffers
              ? [...redeemedOffers, sendOffer]
              : [sendOffer]
          });

        const cashiers = this.state.cashiers.map(cashier => {
          if (cashier.password === this.state.password) {
            return {
              ...cashier,
              counter: cashier.counter + 1
            };
          } else {
            return cashier;
          }
        });

        database
          .ref(`/restaurants/0/${restaurant_name}/offers`)
          .update({ cashiers });

        this.props.history.push('/offer_redeemed');
      } else {
        this.setState({ offerTaken: true });
      }
    } else {
      this.setState({ error: true });

      setTimeout(() => this.setState({ error: false }), 3500);
    }
  };

  deleteNumber = () => {
    const { password } = this.state;

    this.setState({ password: password.substring(0, password.length - 1) });
  };

  handlePassword = num => {
    if (this.state.password.length > 3) {
      return;
    } else {
      this.setState({ password: (this.state.password += num) });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div className='container'>
        <div className='top'>
          <h4>أظهر موبايلك للكاشير لكسب هديتك</h4>
          <p>
            Please, show your mobile to cashier to get your free item (last
            step)
          </p>
        </div>
        <div className='error'>
          <div className='password'>
            <Input
              disableUnderline={true}
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              autoFocus
              type='password'
              className='passwordField'
              inputProps={{
                className: classes.input,
                maxLength: 4
              }}
            />
            <Button className='backspace' onClick={this.deleteNumber}>
              <Backspace />
            </Button>
          </div>
          {this.state.error ? (
            <h4 className='errorMessage'>
              <span>Invalid Code </span> هذا الكود غير صحيح
            </h4>
          ) : null}
        </div>
        <div className='containerNumbers'>
          <div className='number'>
            <div className='grid'>
              {this.state.numbers.map((num, index) => (
                <Button
                  key={index}
                  onClick={() => this.handlePassword(`${num}`)}
                >
                  {num}
                </Button>
              ))}
            </div>
            <div className='grid'>
              <span />
              <Button onClick={() => this.handlePassword('0')}>0</Button>
              <span />
            </div>
          </div>
        </div>
        <button className='submit' onClick={this.validatePassword}>
          submit
        </button>
        <div className='offer-redeemed'>
          {this.state.offerTaken && (
            <div>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                open={this.state.offerTaken}
                autoHideDuration={3500}
                onClose={this.handleClose}
              >
                <MySnackbarContentWrapper
                  variant='error'
                  onClose={this.handleClose}
                  className={classes.margin}
                  message='We Are Sorry, But you have already redeemed this offer!'
                />
              </Snackbar>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const styles = {
  input: {
    fontSize: 50,
    marginTop: 15,
    textAlign: 'center',
    width: 120
  }
};

export default withStyles(styles)(Main);



// WEBPACK FOOTER //
// ./src/lottie/RedeemOffer.js